import { Faq, RichText } from "@/sanity/types";
import { AccordionGeneric } from "../AccordionGeneric/AccordionGeneric";
import styles from "./FaqAccordion.module.scss";
import { PortableTextRichText } from "../PortableTextRichText/PortableTextRichText";
import CaretDownIcon from "@/images/icons/caret-down.svg";

interface FaqAccordionProps {
	title?: string | null;
	content?: RichText | null;
}

export const FaqAccordion = ({ title, content }: FaqAccordionProps) => {
	return (
		title &&
		content && (
			<div className={styles["faq-accordion-wrapper"]}>
				<AccordionGeneric
					className={styles["faq-accordion"]}
					name={title}
					headerAs={"h3"}
					header={
						<div className={styles["faq-accordion__header"]}>
							<span className={styles["faq-accordion__heading"]}>{title}</span>
							<CaretDownIcon />
						</div>
					}
					body={
						<div className={styles["faq-accordion__body"]}>
							<div className={styles["faq-accordion__content"]}>
								{content && <PortableTextRichText value={content} />}
							</div>
						</div>
					}
				/>
			</div>
		)
	);
};
